import React from 'react';
import { Column } from '../contexts/column.context';
import { Row } from '../contexts/row.context';
import { squareToPixel, STRIP_WIDTH } from '../utils/graph.utils';
import { Laddergram } from './Laddergram';
import { StripContent } from './StripContent';
import { STRIP_EDITOR_WIDTH } from './StripEditor';
import { StripWindow } from './StripWindow';

const LADDERGRAM_HEIGHT = squareToPixel(1);

export const LaddergramContainer: React.FC = () => {
  return (
    <Row height={LADDERGRAM_HEIGHT}>
      <Column width={STRIP_WIDTH} offsetLeft={STRIP_EDITOR_WIDTH}>
        <StripContent>
          <StripWindow>
            <Laddergram />
          </StripWindow>
        </StripContent>
      </Column>
    </Row>
  );
};
